var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotificationsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0007 18.125C10.9173 18.125 11.6673 17.375 11.6673 16.4583H8.33398C8.33398 17.375 9.07565 18.125 10.0007 18.125ZM15.0007 13.125V8.95833C15.0007 6.4 13.634 4.25833 11.2507 3.69167V3.125C11.2507 2.43333 10.6923 1.875 10.0007 1.875C9.30898 1.875 8.75065 2.43333 8.75065 3.125V3.69167C6.35898 4.25833 5.00065 6.39167 5.00065 8.95833V13.125L3.33398 14.7917V15.625H16.6673V14.7917L15.0007 13.125Z",
    fill: "#223CDD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsIcon);
export default __webpack_public_path__ + "static/media/Notifications-icon.7b3f9382889b608c1c32278edacd5601.svg";
export { ForwardRef as ReactComponent };